// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2jU0w","productName":"Table_productName__2-s1I"};